export const INC_STEP = 'zola/onboard/INC_STEP';
export const DEC_STEP = 'zola/onboard/DEC_STEP';
export const RESET_STEP = 'zola/onboard/RESET_STEP';
export const CHECK_SLUG_AVAILABLE = 'zola/onboard/CHECK_SLUG_AVAILABLE';
export const SLUG_AVAILABILITY_RECEIVED = 'zola/onboard/SLUG_AVAILABILITY_RECEIVED';
export const PRIMARY_PRODUCT_SELECTED = 'zola/onboard/PRIMARY_PRODUCT_SELECTED';
export const SLUG_SUGGESTIONS_RECEIVED = 'zola/onboard/SLUG_SUGGESTIONS_RECEIVED';
export const REQUEST_UPDATE_SLUG = 'zola/onboard/REQUEST_UPDATE_SLUG';
export const RECEIVE_UPDATED_SLUG = 'zola/onboard/RECEIVE_UPDATED_SLUG';

// New Perfect Onboarding Flow ActionTypes:

export const REQUEST_QUESTIONS = 'zola/onboard/REQUEST_QUESTIONS';
export const RECEIVE_QUESTIONS = 'zola/onboard/RECEIVE_QUESTIONS';
export const UPDATE_QUESTION_NUMBER = 'zola/onboard/UPDATE_QUESTION_NUMBER';
export const REQUEST_SIGNUP = 'zola/onboard/REQUEST_SIGNUP';
export const ONBOARDING_COMPLETED = 'zola/onboard/ONBOARDING_COMPLETED';
export const UPDATE_WEDDING_DATE = 'zola/onboard/UPDATE_WEDDING_DATE';
export const ACCOUNT_CREATED = 'zola/account/created';
export const SET_BUSINESS_UNIT_COMPONENT = 'zola/onboard/SET_BUSINESS_UNIT_COMPONENT';



// WEBPACK FOOTER //
// ./src/actions/types/OnboardActionTypes.js